// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/scheduler/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/scheduler/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Scheduler" })
  return <Page />
}
